import { CSSTransition } from 'react-transition-group';
import cx from './index.module.scss';

const HeaderMask = (props: { show: boolean }) => {
  return (
    <CSSTransition in={props.show} timeout={200} classNames={cx('fade')} unmountOnExit>
      <div className={cx('mask')}></div>
    </CSSTransition>
  );
};

export default HeaderMask;
